import { useEffect } from "react";
import { getEntityTypeFromJWT, getEntityIdFromJWT } from "../utils/secureStorage";
import { fetchUnionDropdownValue } from "../utils";

const ALL_UNION_OPTION = { code: "ALL", desc: "All Union" };

// Union Admins are locked to their own union and cannot switch it.
export const useUnionLock = () => {
  const entityType = getEntityTypeFromJWT() || "";
  const isUnionUser = entityType.toUpperCase() === "UNION";
  const internalUnionId = isUnionUser ? getEntityIdFromJWT() : null;
  return { isUnionUser, internalUnionId };
};

export const getInitialUnionId = (isUnionUser, internalUnionId) =>
  isUnionUser && internalUnionId
    ? { code: internalUnionId, desc: "" }
    : ALL_UNION_OPTION;

// Fetches the union dropdown, prepends "All Union", and locks the union
// admin's own union into `unionId` once the matching option resolves.
export const useUnionDropdown = (setUnionOptions, setUnionId, isUnionUser, internalUnionId) => {
  useEffect(() => {
    const run = async () => {
      try {
        let fetchedOptions = [];
        await fetchUnionDropdownValue((options) => { fetchedOptions = options; });
        setUnionOptions([ALL_UNION_OPTION, ...fetchedOptions]);
        if (isUnionUser && internalUnionId) {
          const matched = fetchedOptions.find((u) => u.code == internalUnionId);
          if (matched) setUnionId(matched);
        }
      } catch (err) {
        console.error(err);
      }
    };
    run();
  }, [setUnionOptions, setUnionId, isUnionUser, internalUnionId]);
};
